import React, { FunctionComponent } from 'react'
import { useIsDarkMode, Text } from '@afterpaytouch/core'

import { BASE_PATH } from '../../../../env'
import { useMerchantDisplayNameOrName } from '../../../../state'
import Image from 'next/image'
import styles from './styles.module.css'

export const Header: FunctionComponent = () => {
  const logoSrc__light = [BASE_PATH, 'images/merchant-logo/apple.png'].join('/')
  // TODO: checking with designer
  const logoSrc__dark = [BASE_PATH, 'images/merchant-logo/apple.png'].join('/')

  const isDarkMode = useIsDarkMode()
  const logoSrc = isDarkMode ? logoSrc__dark : logoSrc__light
  const merchantName = useMerchantDisplayNameOrName()

  return (
    <div className={styles.component}>
      <div className={styles.logoContainer}>
        <Image
          src={logoSrc}
          alt='eye-id'
          width='64'
          height='64'
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
      <div className={styles.merchantNameContainer}>
        <Text size='XL' renderAs='div' bold>
          {merchantName}
        </Text>
      </div>
    </div>
  )
}
